import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import theme from './src/gatsby-theme-material-ui-top-layout/theme.js'

export default ({ element }) => <ThemeProvider theme={theme}>{element}</ThemeProvider>
